import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AccordionComponent } from '../../../../shared/components/accordion/accordion.component';
import {
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import {
  PAGE_CONSTANTS,
  TABS,
} from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import {
  DialogService,
  DialogConfig,
} from '../../../../shared/services/dialog.service';
import { TimesheetViewComponent } from '../timesheet-view/timesheet-view.component';
import { TimesheetNewEntriesComponent } from '../timesheets-add-entries/timesheets-add-entries.component';
import { LookupService } from '../../../../services/lookup.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { ListService } from '../../../../shared/services/list.service';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-timesheet-consumer-list',
  standalone: true,
  imports: [
    AccordionComponent,
    ListTableComponent,
    NgZorroModule,
    ButtonComponent,
    AuthorizeDirective,
    NzSelectModule,
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
    TimesheetViewComponent,
  ],
  templateUrl: './timesheet-consumer-list.component.html',
  styleUrl: './timesheet-consumer-list.component.css',
})
export class TimesheetConsumerListComponent implements OnInit {
  @ViewChild('inProcessTimesheetChildComponent') inProcessTimesheetChildComponent?: ListTableComponent;
  @ViewChild('completedTimesheetChildComponent') completedTimesheetChildComponent?: ListTableComponent;
  entry!: string;
  sharedDataKey: string = STATIC_DATA.SHARED_REFERRAL_DATA;
  pageId: string = PAGE_CONSTANTS.PROVIDER_LEADS_DATA_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  actionButtonsProcessed: TableRowActionsModel = new TableRowActions({
    view: true,
  });
  actionButtonsInProcess: TableRowActionsModel = new TableRowActions({
    view: true,
  });
  @ViewChild('timesheetViewDialog') timesheetViewDialog!: TemplateRef<any>;
  @ViewChild('denyDialog') denyDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  tabId: string = TABS.TIMESHEET;
  inProcessTimesheetSearchForm!: FormGroup;
  timesheetSearchForm!: FormGroup;
  programName!: string;
  timeEntry = '';
  isProcessed = false;
  listOfOption: any;
  selectedReason = '';
  consumerId: any;
  consumerLineData: any;
  providerPplId: any;
  rowData: any;
  providers: any[] = [];
  payPeriod: any[] = [];
  inProcessConsumerTimesheets: any[] = [];
  processedConsumerTimesheets: any[] = [];
  viewDialogId: any;
  businessStatusList: any;
  processingStatusList: any;
  reasonList: any;

  inProcessFilterStatus = [
    {
      lkpValueCode: 'AC',
      lkpValueName: 'Awaiting consumer approval',
    },
    {
      lkpValueCode: 'CD',
      lkpValueName: 'Consumer rejected',
    },
    {
      lkpValueCode: 'GP',
      lkpValueName: 'Good to pay',
    },
    {
      lkpValueCode: 'I',
      lkpValueName: 'In review',
    },
  ];

  status = [
    {
      lkpValueCode: 'D',
      lkpValueName: 'Denied',
    },
    {
      lkpValueCode: 'P',
      lkpValueName: 'Paid',
    },
  ];

  cols = [
    {
      field: 'providerName',
      header: 'PA Name',
      jsonpath: 'providerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerPplId',
      header: 'PA PPL ID',
      jsonpath: 'providerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDate',
      header: 'Service Date',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeIn',
      header: 'Time In',
      jsonpath: 'timeIn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeOut',
      header: 'Time Out',
      jsonpath: 'timeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    // {
    //   field: 'payrollStartDate',
    //   header: 'Payroll Start Date',
    //   jsonpath: 'payrollStartDate',
    //   isDisplayedAtHeader: 'y',
    //   isSearchable: 'n',
    // },
    // {
    //   field: 'payrollEndDate',
    //   header: 'Payroll End Date',
    //   jsonpath: 'payrollEndDate',
    //   isDisplayedAtHeader: 'y',
    //   isSearchable: 'n',
    // },
    {
      field: 'businessStatus',
      header: 'Status',
      jsonpath: 'businessStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];

  constructor(
    private fb: FormBuilder,
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService,
    private lookupService: LookupService,
    private timesheetService: TimesheetService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private listService: ListService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry() ?? '';
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.consumerId = this.userService.getSelectedLead()!;

    this.businessStatusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.reasonList = this.lookupService.getLookupValue('Manual Entry reason');

    const denyReasons = this.lookupService.getLookupValue(
      'consumer_ts_denial'
    );
    this.listOfOption = denyReasons.map((item: any) => item.lkpValueName);

    this.inProcessTimesheetSearchForm = this.fb.group({
      paPplId: [null],
      paName: [null],
      status: [null],
    });
    this.timesheetSearchForm = this.fb.group({
      payPeriod: [null],
      provider: [null],
      status: [null],
    });
    this.setPageAccess();
    this.getProviders();
    this.getPayPeriod();
    this.loadInitData();
  }

  loadInitData() {
    this.loadInProgressData();
    this.loadProcessedData();
  }

  onInProcessTimesheetPageLoad(event: any) {
    this.loadInProgressData(event.startingPageNumber ?? 1, event.first ?? 0);
  }

  onCompletedTimesheetPageLoad(event: any) {
    this.loadProcessedData(event.startingPageNumber ?? 1, event.first ?? 0);
  }

  loadProcessedData(startingPageNumber = 1, currentPage = 0) {
    const processedPayload = this.buildRequestPayload('consumerTimesheetCompletedList', startingPageNumber);
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const filteredRecords = this.filterRecords(data.responsedata);
        const processedData = this.processTimesheetData(filteredRecords);

        if (startingPageNumber > 1) {
          this.processedConsumerTimesheets = [...this.processedConsumerTimesheets, ...processedData];
        } else {
          this.processedConsumerTimesheets = processedData;
        }

        if (this.completedTimesheetChildComponent) {
          this.completedTimesheetChildComponent.resetPagination(startingPageNumber, currentPage);
        }
        this.timesheetSearchForm.reset();
      });
  }

  loadInProgressData(startingPageNumber = 1, currentPage = 0) {
    const inProcessPayload = this.buildRequestPayload('consumerTimesheetProcessList', startingPageNumber);
    this.listService
      .getListData(inProcessPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.processInProcessConsumerTimesheets(data.responsedata);
        this.inProcessTimesheetSearchForm.reset();

        if (startingPageNumber > 1) {
          this.inProcessConsumerTimesheets = [...this.inProcessConsumerTimesheets, ...records];
        } else {
          this.inProcessConsumerTimesheets = records;
        }

        if (this.inProcessTimesheetChildComponent) {
          this.inProcessTimesheetChildComponent.resetPagination(startingPageNumber, currentPage);
        }
      });
  }

  processInProcessConsumerTimesheets(responseData: any) {
    responseData.sort((a: any, b: any) => {
      const dateA = new Date(a.serviceDate + ' ' + a.timeIn) as any;
      const dateB = new Date(b.serviceDate + ' ' + b.timeIn) as any;

      // Sorts by serviceDate and timeIn in ascending order
      return dateA - dateB;
    });

    responseData.map((entry: any) => {
      entry.actions = {};
      const businessStatus = this.businessStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === entry.business_status_lkp;
      });

      if (businessStatus) {
        entry.businessStatus = businessStatus.lkpValueName;
        if (businessStatus.lkpValueCode === "AC") {
          entry.actions.approve = true;
          entry.actions.deny = true;
        }
      }
    });

    return responseData;
  }

  filterRecords(data: any) {
    data.sort((a: any, b: any) => {
      const dateA = new Date(a.payrollStartDate);
      const dateB = new Date(b.payrollStartDate);
      return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
    });

    return data;
  }

  updated(event: any) {
    if (event) {
      if (this.viewDialogId) {
        this.dialogSvc.closeDialog(this.viewDialogId);
        this.loadInitData();
        this.viewDialogId = null;
      }
    }
  }

  buildRequestPayload(pageName: string, startingPageNumber: number) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: [
        {
          jsonPath: 'participantId',
          value: this.consumerId,
          operator: 'Equal',
        },
      ],
      orderByColumn: ['tasMasterPayrollScheduleId'],
      orderBy: ['desc'],
    };

    return payload;
  }

  getProviders() {
    this.timesheetService
      .getProviderList(this.programName, this.consumerId)
      .subscribe((data: any) => {
        this.providers = data.responsedata;
      });
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService
        .fetchPageAuthorization(this.programName, this.pageId, 'LIST')
        .subscribe((response) => {
          this.setRestrictions(response);
        });
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(
        pageConfig,
        this.pageId
      );
      this.actionsToBeHidden = this.authUtility.getHiddenActions(
        pageConfig,
        this.pageId
      );
    }
    this.isPageRestrictionLoaded = true;
  }

  onView(eventData: any) {
    this.providerPplId = eventData?.providerPplId;
    const filters = [
      {
        jsonPath: "timesheetLineId",
        value: eventData?.timesheetLineId,
        operator: "Equal"
      },
    ];

    const processedPayload = this.buildTimesheetRequestPayload(
      'staffEditTimesheetEntry',
      filters
    );

    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        this.consumerLineData = this.processData(data.responsedata, eventData);
        this.openViewPopup();
      });
  }

  buildTimesheetRequestPayload(pageName: string, searchParams: any) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: searchParams,
      orderByColumn: [],
      orderBy: ['desc'],
    };

    return payload;
  }

  processData(data: any[], eventData: any) {
    data.forEach(e => {
      if (eventData?.providerName) {
        e.providerName = eventData.providerName;
      }

      const businessStatus = this.businessStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.businessStatusLkp;
      });

      if (businessStatus) {
        e.businessStatus = businessStatus.lkpValueName;
      }

      const processingStatus = this.processingStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.processingStatusLkp;
      });

      if (processingStatus) {
        e.processingStatus = processingStatus.lkpValueName;
      }

      const reason = this.reasonList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.reasonLkp;
      });

      if (reason) {
        e.reason = reason.lkpValueName;
      }

      if (STATIC_DATA.STATUS_FOR_AUTH.includes(e.businessStatusLkp) || STATIC_DATA.PROCESSING_STATUS_FOR_AUTH.includes(e.processingStatusLkp)) {
        e.authNum = 'View';
      }
      e.tasTimesheetlineDetailId = e.timesheetLineId
    });

    data.sort((a, b) => {
      const dateA = new Date(a.serviceDate);
      const dateB = new Date(b.serviceDate);
      return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
    });

    return data;
  }

  convertTo12HourFormat(time: string): string {
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const adjustedHour = hours % 12 || 12;
    const formattedTime = `${adjustedHour}:${minutes < 10 ? '0' + minutes : minutes} ${period}`;
    return formattedTime;
  }

  inProcessTimesheetSearch() {
    const formData = this.inProcessTimesheetSearchForm.value;
    const searchParam: { jsonPath: string; value: any; operator: string }[] = [
      {
        jsonPath: 'participantId',
        value: this.consumerId,
        operator: 'Equal',
      },
    ];

    if (formData.paPplId && formData.paPplId.trim()) {
      searchParam.push({
        jsonPath: 'providerPplId',
        value: formData.paPplId.trim(),
        operator: 'Equal',
      });
    }

    if (formData.paName) {
      searchParam.push({
        jsonPath: 'providerId',
        value: formData.paName,
        operator: 'Equal',
      });
    }

    if (formData.status) {
      searchParam.push({
        jsonPath: 'business_status_lkp',
        value: formData.status,
        operator: 'Equal',
      });
    }

    const payload = {
      pageName: 'consumerTimesheetProcessList',
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: 1,
      searchParam: searchParam,
      orderByColumn: ['tasMasterPayrollScheduleId'],
      orderBy: ['desc'],
    };

    this.listService.getListData(payload, 'claims').subscribe((data: any) => {
      this.inProcessConsumerTimesheets = this.processInProcessConsumerTimesheets(data.responsedata);
    });
  }

  search() {
    const formData = this.timesheetSearchForm.value;
    const searchParam: { jsonPath: string; value: any; operator: string }[] = [
      {
        jsonPath: 'participantId',
        value: this.consumerId,
        operator: 'Equal',
      },
    ];

    if (formData.provider) {
      searchParam.push({
        jsonPath: 'providerId',
        value: formData.provider,
        operator: 'Equal',
      });
    }

    if (formData.status) {
      searchParam.push({
        jsonPath: 'businessStatusLkp',
        value: formData.status,
        operator: 'Equal',
      });
    }

    if (formData.payPeriod) {
      searchParam.push({
        jsonPath: 'tasMasterPayrollScheduleId',
        value: formData.payPeriod.payrollId,
        operator: 'Equal',
      });
    }

    const payload = {
      pageName: 'consumerTimesheetCompletedList',
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: 1,
      searchParam: searchParam,
      orderByColumn: ['tasMasterPayrollScheduleId'],
      orderBy: ['desc'],
    };

    this.listService.getListData(payload, 'claims').subscribe((data: any) => {
      this.processedConsumerTimesheets = this.processTimesheetData(data.responsedata);
    });
  }

  processTimesheetData(processedTimesheets: any) {
    return processedTimesheets.map((entry: any) => {
      const businessStatus = this.businessStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === entry.businessStatusLkp;
      });

      if (businessStatus) {
        entry.businessStatus = businessStatus.lkpValueName;
      }

      return entry;
    });
  }

  createUpdatePayload(status: string) {
    return {
      timesheetIds: [this.rowData?.timesheetLineId],
      status: status,
      programCode: this.programName,
      participantId: this.rowData?.participantId || null,
      providerId: this.rowData?.providerId || null,
      remarks: this.selectedReason,
    };
  }

  onAction(event: any, isProcessed: boolean) {
    this.isProcessed = isProcessed;
    this.rowData = event.data;
    if (event.action === 'view') {
      if (event?.data?.business_status_lkp === "AC") {
        this.isProcessed = false;
      }

      this.onView(event.data);
    }
    if (event.action === 'deny') {
      this.openDenyPopup();
    }
    if (event.action === 'approve') {
      this.updateStatus('GP');
    }
  }

  updateStatus(status: string) {
    const payload = this.createUpdatePayload(status);
    this.timesheetService
      .updateStatusConsumerTimesheet(payload, status)
      .subscribe((data: any) => {
        console.log('after update status timesheet', data);
        this.loadInitData();
      });
  }

  openViewPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Timesheet',
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.viewDialogId = this.dialogSvc.openDialog(
      this.timesheetViewDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openDenyPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Deny Payroll',
      isOkText: 'Deny',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.denyDialog,
      dialogConfig,
      () => this.handleOk(),
      () => this.handleCancel()
    );
  }

  handleCancel() {
    this.selectedReason = '';
  }

  handleOk() {
    this.updateStatus('CD');
  }
}
